import React , { useState , useMemo , useEffect } from 'react'

import Layout from '../../components/layout/layout'
import { menuItem } from '../../utils/helper'

import GenericTreeList from '../../components/tree-list/tree-list'

import "./index.css"


const dummayData = [
    {
        id:1,
        Name:"General",
        Abbreviation:"",
        DataType:"",
        Required:null,
        isFolder:true,
        parentId:null
    },
    {
        id:2,
        Name:"Analysis Set",
        Abbreviation:"POPU",
        DataType:"",
        Required:null,
        isFolder:true,
        parentId:null
    },
    {
        id:3,
        Name:"Demographics and Baseline",
        Abbreviation:"DEMO",
        DataType:"",
        Required:null,
        isFolder:true,
        parentId:null
    },
    {
        id:4,
        Name:"Medical History",
        Abbreviation:"MH",
        DataType:"",
        Required:null,
        isFolder:true,
        parentId:null
    },
    {
        id:5,
        Name:"Concomitant Medication",
        Abbreviation:"CM",
        DataType:"",
        Required:null,
        isFolder:true,
        parentId:null
    },
    {
        id:6,
        Name:"Endpoints",
        Abbreviation:"EPT",
        DataType:"",
        Required:null,
        isFolder:true,
        parentId:null
    },
    {
        id:7,
        Name:"Statistical Methods",
        Abbreviation:"STAT",
        DataType:"",
        Required:null,
        isFolder:true,
        parentId:null
    },
    {
        id:8,
        Name:"Adverse Events",
        Abbreviation:"AE",
        DataType:"",
        Required:null,
        isFolder:true,
        parentId:null
    },
    {
        id:9,
        Name:"Laboratory Data",
        Abbreviation:"LB",
        DataType:"",
        Required:null,
        isFolder:true,
        parentId:null
    },
]

const childdata = [
      {
        id:21,
        Name:"Name",
        Abbreviation:"",
        DataType:"Character",
        Required:true,
        isFolder:false,
        parentId:1
    },
      {
        id:22,
        Name:"Abbreviation",
        Abbreviation:"",
        DataType:"Character",
        Required:true,
        isFolder:false,
        parentId:1
    },
      {
        id:33,
        Name:"Description",
        Abbreviation:"",
        DataType:"Character",
        Required:true,
        isFolder:false,
        parentId:1
    },
      {
        id:44,
        Name:"Treatment",
        Abbreviation:"",
        DataType:"Character",
        Required:true,
        isFolder:false,
        parentId:1
    },
      {
        id:55,
        Name:"Usage",
        Abbreviation:"",
        DataType:"Character",
        Required:true,
        isFolder:false,
        parentId:1
    },
]

const attachChildrenToAllParents = (parents, childTemplate) => {
  let newId = 100; // start new ids from here

  const allChildren = parents.flatMap(parent => {
    return childTemplate.map(child => ({
      ...child,
      id: newId++,                 // unique id
      parentId: parent.id          // attach to current parent
    }));
  });

  return [...parents, ...allChildren];
};


const DataSchema = ( { location } ) =>{
    const [ data , setdata ] = useState([])
    useEffect(()=>{
       setdata( attachChildrenToAllParents( dummayData , childdata ) )
    },[])
    return(
        <Layout menuItem={menuItem} location={location}>
             <GenericTreeList
                data={data}
                idField="id"
                parentIdField="parentId"
                subItemsField="items"
                columnType = "DataSchema"
             /> 
        </Layout>
    )
}

export default DataSchema